import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
const yesList = ["You've been circling the same relationship decision for more than 2 weeks.", "You've prayed about it, journaled about it, and asked 3+ people — and you're still stuck.", 'You feel the difference between "peace" and "pressure" but can\'t trust which one is driving you right now.', 'You\'ve confused "staying because it feels safe" with "staying because it\'s right."', "You know there's a conversation you've been avoiding — and the longer you wait, the louder the noise gets.", "You're spiritually open or actively Christian and you want clarity that honors both your faith and your wisdom."];
const noList = ["You're looking for someone to tell you what to decide. (This framework gives you a process — not an answer.)", "You're in immediate danger or crisis. (Please seek professional support. This guide is educational, not clinical.)", "You want a magic formula that bypasses wisdom, prayer, and counsel. (There isn't one. But there is a 5-minute filter that makes everything clearer.)"];
export function WhoIsThisFor() {
  return <section className="py-20 md:py-28 px-4 bg-warm-gray watermark-bg" data-id="element-304">
      <div className="max-w-5xl mx-auto" data-id="element-305">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-306">
          {/* YES Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-green-500" data-id="element-307">
            <h3 className="text-2xl font-bold mb-8 text-charcoal" data-id="element-308">
              This Was Made For You If…
            </h3>
            <ul className="space-y-6" data-id="element-309">
              {yesList.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-310">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-311" />
                  <span className="text-charcoal/80 leading-relaxed" data-id="element-312">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-red-400" data-id="element-313">
            <h3 className="text-2xl font-bold mb-8 text-charcoal" data-id="element-314">
              This Is NOT For You If…
            </h3>
            <ul className="space-y-6" data-id="element-315">
              {noList.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-316">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-317" />
                  <span className="text-charcoal/80 leading-relaxed" data-id="element-318">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-12 text-center" data-id="element-319">
          <CTAButton mainText="THIS IS FOR ME — $17.95" subText="Get clarity on your loudest relationship decision tonight." large data-id="element-320" />
        </div>
      </div>
    </section>;
}